export default __webpack_public_path__ + "static/media/small_cyrus.861722eb.png";